"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createIconComponent = _interopRequireDefault(require("./utils/createIconComponent"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconCrossHeavy = (0, _createIconComponent["default"])({
  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M39.95 35l23.16-23.16a3.5 3.5 0 0 0-4.95-5L35 30.05 11.84 6.89a3.5 3.5 0 0 0-4.95 5L30.05 35 6.89 58.16a3.5 3.5 0 1 0 4.95 5L35 39.95l23.16 23.16a3.5 3.5 0 1 0 4.95-5z"
  })),
  height: undefined,
  width: undefined
});
IconCrossHeavy.displayName = 'IconCrossHeavy';
var _default = IconCrossHeavy;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@tecuity/sos-icons/react/cross-heavy.js
// module id = 51
// module chunks = 0